import Error403 from "src/assets/illustrations/403_error.svg?react";
import * as styles from "src/components/AccessDenied/AccessDenied.style.ts";
import { Flex } from "src/components/Flex.tsx";
import { H4 } from "src/components/HeadingV2/HeadingV2.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const AccessDenied = () => {
  const { t } = useTranslation(TranslationNamespaceEnum.Common);
  return (
    <div css={styles.root}>
      <Flex gap={"30px"} alignItems={"center"}>
        <Error403 />
        <div css={styles.errorCode}>403</div>
      </Flex>

      <H4
        style={{
          marginTop: "10px",
        }}
      >
        {t("403error.title")}
      </H4>
    </div>
  );
};
